import { type ReactNode } from 'react';
import { Spinner } from '@/components/ui/spinner';
import { Button } from '@/components/ui/button';
import {
  useSettingsState,
  type SettingsState,
} from '../hooks/use-settings-state';
import { ActivityCard } from './settings-activity-card';
import { PaymentsCard } from './settings-payments-card';
import { GoalsCard } from './settings-goals-card';
import { SystemCard } from './settings-system-card';

const ALL_KEYS = [
  'daily_minimum_leads',
  'top_tier_threshold',
  'top_tier_days_required',
  'pre_ban_failed_days_threshold',
  'pre_ban_grace_days',
  'payment_threshold',
  'payment_day_of_week',
  'minimum_payout_banned',
  'weekly_goal',
  'total_goal',
  'group_bonus_amount',
  'bonus_period',
  'bonus_amounts',
  'ranking_period',
  'daily_first_to_x_enabled',
  'daily_first_to_x_threshold',
  'daily_first_to_x_amount_usd',
  'weekly_first_to_x_enabled',
  'weekly_first_to_x_threshold',
  'weekly_first_to_x_amount_usd',
  'monthly_first_to_x_enabled',
  'monthly_first_to_x_threshold',
  'monthly_first_to_x_amount_usd',
];

function SettingsCards({ s }: { s: SettingsState }): ReactNode {
  return (
    <div className="grid grid-cols-1 gap-lg lg:grid-cols-2">
      <ActivityCard cfg={s.cfg} set={s.set} />
      <PaymentsCard cfg={s.cfg} set={s.set} />
      <GoalsCard cfg={s.cfg} set={s.set} />
      <SystemCard />
    </div>
  );
}

export function SettingsPage(): ReactNode {
  const s = useSettingsState();
  if (s.loading) return <Spinner />;
  return (
    <div className="space-y-lg">
      <SettingsCards s={s} />
      <Button
        size="sm"
        onClick={() => s.submitGroup(ALL_KEYS)}
        disabled={s.isPending}
      >
        Guardar configuración
      </Button>
    </div>
  );
}
